import {
	TIDSelectedTypeApk,
	TActiveItemToDisplay,
	TTypeOfModalWindow,
	IIDsSelectedItems,
	IApkWithAdditionalProperty,
} from './apkAssignmentContext';
import { IApkForAssign, IDataGetRestaurantsByIDsCustomersForApk, IDataGetCustomersForAssignApk } from 'types';

export enum ApkAssignmentActionTypes {
	SET_APK_FOR_ASSIGN = 'SET_APK_FOR_ASSIGN',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS = 'CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS',
	CHANGE_SEARCH_STRING_FOR_RESTAURANTS = 'CHANGE_SEARCH_STRING_FOR_RESTAURANTS',
	CHANGE_SEARCH_STRING_FOR_APK = 'CHANGE_SEARCH_STRING_FOR_APK',
	CHANGE_TYPE_APK = 'CHANGE_TYPE_APK',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	CHANGE_UNASSIGNED_APK_STATUS = 'CHANGE_UNASSIGNED_APK_STATUS',
	SET_IDS_SELECTED_APK = 'SET_IDS_SELECTED_APK',
	CHANGE_ACTIVE_ITEM_TO_DISPLAY = 'CHANGE_ACTIVE_ITEM_TO_DISPLAY',
	SET_SHOW_BREADCRUMBS = 'SET_SHOW_BREADCRUMBS',
	SET_ALL_CUSTOMERS = 'SET_ALL_CUSTOMERS',
	SET_IDS_SELECTED_CUSTOMERS = 'SET_IDS_SELECTED_CUSTOMERS',
	SET_IDS_SELECTED_RESTAURANTS = 'SET_IDS_SELECTED_RESTAURANTS',
	SET_APK = 'SET_APK',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	RESET_CHANGES = 'RESET_CHANGES',
}

interface ISetApkForAssign {
	type: ApkAssignmentActionTypes.SET_APK_FOR_ASSIGN;
	payload: {
		apkForAssign: IApkForAssign;
	};
}

interface IChangeSearchString {
	type: ApkAssignmentActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface IChangeSearchStringForAllCustomers {
	type: ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS;
	payload: {
		searchStringForAllCustomers: string;
	};
}

interface IChangeSearchStringForRestaurants {
	type: ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS;
	payload: {
		searchStringForRestaurants: string;
	};
}

interface IChangeSearchStringForApk {
	type: ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_APK;
	payload: {
		searchStringForApk: string;
	};
}

interface IChangeTypeApk {
	type: ApkAssignmentActionTypes.CHANGE_TYPE_APK;
	payload: {
		IDSelectedTypeApk: TIDSelectedTypeApk;
	};
}

interface IResetSelectedControls {
	type: ApkAssignmentActionTypes.RESET_SELECTED_CONTROLS;
}

interface IChangeIsUnassignedApkStatus {
	type: ApkAssignmentActionTypes.CHANGE_UNASSIGNED_APK_STATUS;
	payload: {
		isUnassignedApk: boolean;
	};
}

interface ISetIDsSelectedApk {
	type: ApkAssignmentActionTypes.SET_IDS_SELECTED_APK;
	payload: {
		IDsSelectedApk: string[];
	};
}

interface IChangeActiveItemToDisplay {
	type: ApkAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY;
	payload: {
		activeItemToDisplay: TActiveItemToDisplay;
	};
}

interface ISetShowBreadcrumbs {
	type: ApkAssignmentActionTypes.SET_SHOW_BREADCRUMBS;
	payload: {
		isShowBreadCrumbs: boolean;
	};
}

interface ISetAllCustomers {
	type: ApkAssignmentActionTypes.SET_ALL_CUSTOMERS;
	payload: {
		allCustomers: IDataGetCustomersForAssignApk[];
	};
}

interface ISetIDsSelectedCustomers {
	type: ApkAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS;
	payload: {
		IDsSelectedCustomers: IIDsSelectedItems;
		restaurants: IDataGetRestaurantsByIDsCustomersForApk[];
		IDsSelectedRestaurants: IIDsSelectedItems;
		apk: IApkWithAdditionalProperty[];
	};
}

interface ISetIDsSelectedRestaurants {
	type: ApkAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS;
	payload: {
		IDsSelectedRestaurants: IIDsSelectedItems;
		apk: IApkWithAdditionalProperty[];
	};
}

interface ISetApk {
	type: ApkAssignmentActionTypes.SET_APK;
	payload: {
		apk: IApkWithAdditionalProperty[];
		IDsSelectedApk: string[];
	};
}

interface IChangeTypeOfModalWindow {
	type: ApkAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeCurrentPage {
	type: ApkAssignmentActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface IResetChanges {
	type: ApkAssignmentActionTypes.RESET_CHANGES;
}

export type TApkAssignmentAction =
	| ISetApkForAssign
	| IChangeSearchString
	| IChangeSearchStringForAllCustomers
	| IChangeSearchStringForRestaurants
	| IChangeSearchStringForApk
	| IChangeTypeApk
	| IResetSelectedControls
	| IChangeIsUnassignedApkStatus
	| ISetIDsSelectedApk
	| IChangeActiveItemToDisplay
	| ISetShowBreadcrumbs
	| ISetAllCustomers
	| ISetIDsSelectedCustomers
	| ISetIDsSelectedRestaurants
	| ISetApk
	| IChangeTypeOfModalWindow
	| IChangeCurrentPage
	| IResetChanges;
